import Swiper from "swiper";
import {
  A11y,
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
  Scrollbar,
  Thumbs,
} from "swiper/modules";

export default Swiper;
export {
  A11y,
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
  Scrollbar,
  Thumbs
};

